import axios from 'axios'; // eslint-disable-line

export const getCloverToken = (username, password) => {
    return axios({
        url: `${window.GENESIS_CMS_API_URL}/v2/clover/getauthtoken`,
        data: {
            Username: username,
            Password: password,
        },
        method: 'POST',
    });
};

export const getCloverProductsViaAPI = (tokenResponse) => {
    return axios.get(`${window.GENESIS_CLOVER_ACCOUNTS_URL}/api/v1/products`, {
        headers: {
            Authorization: `Bearer ${tokenResponse.data.data.access_token}`,
        },
    });
};

export const getCloverPayloadFromProductViaAPI = (productName, token) => {
    return axios.get(`${window.GENESIS_CLOVER_API_URL}/v1/sites/${productName}/payload`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
